import { createRoot } from 'react-dom/client'

import 'antd/dist/reset.css'

import { initLocale } from 'bit-ui_component_lib-b2b'
import { initDayjs } from './dayjs/dayjs.util'

import { Root } from './Root'

initLocale()
initDayjs()

// biome-ignore lint/style/noNonNullAssertion: no fallback defined
const container = document.getElementById('app')!
const root = createRoot(container)
root.render(<Root />)
